module.exports = __webpack_public_path__ + "static/media/mgo_3_1_ws.f431da6a.pdf";